import React from 'react'
import './Feature.css' 

const Feature = () => {
  return (
    <div>Feature</div>
  )
}

export default Feature